const executeIfFunction = <Wrapped>(f: Wrapped): Wrapped =>
    typeof f === 'function' ? f() : f;

const switchf =
    <ValueType>(cases: { [key: PropertyKey]: ValueType }) =>
    (defaultCase: ValueType) =>
    (key: PropertyKey) =>
        Object.prototype.hasOwnProperty.call(cases, key) ? cases[key] : defaultCase;

export const switchCase =
    <KeyType extends PropertyKey, ValueType>(cases: { [key in KeyType]: ValueType }) =>
    (defaultCase: ValueType) =>
    (key: KeyType) =>
        executeIfFunction<ValueType>(switchf<ValueType>(cases)(defaultCase)(key));
